import { styled } from '@mui/material/styles'

export const StyledEventBoxWrapper = styled('div')`
  width: 100%;
  position: relative;
  display: flex;
  align-items: flex-start;
  font-weight: 700;
`
